import apiClient from '../client/api-client'
const partners = 'partners'
const idInquiry = 'id-inquiry'

export default {
  /*
      Fetches identification by id
  */
  async fetchId(id) {
    try {
      const { data } = await apiClient.get(`/${partners}/${idInquiry}/${id}`)
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  }
}
